<template>
  <div>
      {{time}}
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CountDown',
  props: ['date'],
  data () {
    return {
      time: null,
    }
  },
  created() {
    setInterval(() => this.updateTime(), 1 * 1000)
  },
  // computed:{
  //     date: function(){

  //     }
  // },
  methods: {
    updateTime() {
      this.time = this.$moment(this.date).format('hh:mm:ss')
    },
  },
}
</script>

<style>

</style>
